import { DBDef_FHIRQuery } from '@app/fhir-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_FHIRQuery, ModuleFE_FHIRResourceParam, ModuleFE_FHIRResourceParamValue, ModuleFE_FHIRResourceSubtype } from '../../_entity.js';
import { Manager_FHIRQuery } from '../../ui/_managers/Manager_FHIRQuery/Manager_FHIRQuery.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_FHIRQuery,
    dbDef: DBDef_FHIRQuery,
    tag: ['Hq', 'FHIR Query'],
    modulesToAwait: [ModuleFE_FHIRQuery, ModuleFE_FHIRResourceSubtype, ModuleFE_FHIRResourceParam, ModuleFE_FHIRResourceParamValue],
    ManagerComponent: Manager_FHIRQuery,
});
export const WorkHubItem_FHIRQuery = WorkHubItem;
export const UtilObject_FHIRQuery = UtilObject;
export const SearchItem_FHIRQuery = SearchItem;
//# sourceMappingURL=fhir-query.js.map